import React, { useState, useEffect } from "react";
import axios from "axios";
import Header from "../Components/header";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";

const apiKey = "AIzaSyAP79c41-9Oz4BJZvs_qOgyAIbiZMZ4k2s";
const apiUrl = "https://www.googleapis.com/youtube/v3/search";

const Video = () => {
  const location = useLocation();
  const embedId = "HKt90TP_ULo?si=Z4k9s_0EhH3-NNJD";
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      axios.defaults.withCredentials = false;
      try {
        const response = await axios.get(apiUrl, {
          params: {
            part: "snippet",
            type: "video",
            channelId: "UCZ5ap7dZHk54y0IrHbG80dw",
            key: apiKey,
            order: "date",
            maxResults: 8, // Limit results for a cleaner display
          },
        });
        setVideos(response.data.items);
      } catch (error) {
        console.error("Error fetching videos:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div>
      <Header />
      <Helmet>
        <title>Modellistica International- Video</title>
        <meta
          name="description"
          content="Scopri il mondo dell'aeromodellismo e modellismo con Modellistica International, la rivista dedicata agli appassionati."
        />
        <meta
          name="keywords"
          content="modellistica, aeromodelli, modellistica international, modellismo, abbonamenti modellismo, rivista modellistica abbonamento, chi siamo"
        />
        <link
          rel="canonical"
          href={`https://www.riccardobenincasa.com${location.pathname}`}
        />
      </Helmet>
      <div className="flex flex-col items-center py-4 px-8">
        <h1 className="text-4xl font-bold mb-6 text-center">I nostri video</h1>
        <p className="text-lg mb-8 text-center text-gray-600">
          Rimani aggiornato con i nostri ultimi contenuti del canale
          Modellistica International!
        </p>
        <YoutubeComponent videos={videos} />
      </div>
    </div>
  );
};

const YoutubeComponent = ({ videos }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
    {videos.length > 0 ? (
      videos.map((video) => (
        <div
          key={video.id.videoId}
          className="bg-white shadow-lg rounded-lg overflow-hidden transition-transform transform hover:scale-105"
        >
          <iframe
            className="w-full h-56"
            src={`https://www.youtube.com/embed/${video.id.videoId}`}
            title={video.snippet.title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
          <div className="p-4">
            <h2 className="text-lg font-semibold mb-2">
              {video.snippet.title}
            </h2>
            <p className="text-sm text-gray-600">{video.snippet.description}</p>
          </div>
        </div>
      ))
    ) : (
      <p className="text-center text-gray-500 col-span-full">No videos found</p>
    )}
  </div>
);

YoutubeComponent.propTypes = {
  videos: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.shape({
        videoId: PropTypes.string.isRequired,
      }).isRequired,
      snippet: PropTypes.shape({
        title: PropTypes.string.isRequired,
        description: PropTypes.string,
      }).isRequired,
    })
  ).isRequired,
};

export default Video;
